import * as AT from "./actionTypes";

export const addToLoading = (actionType: string) => ({
    type: AT.LOADING_ADD,
    actionType,
});

export const removeFromLoading = (actionType: string) => ({
    type: AT.LOADING_REMOVE,
    actionType,
});
